/* eslint-disable */
<template>
  <div class="loginInput" :class="{notValid: isNotValid || isNotValidData, selectMask: showSelectButton}" tabindex="-1">
    <div v-if="showSelectButton" class="selectButton">
      <login-select-code :select-array="selectArray" @setItem="selectItemSet"></login-select-code>
    </div>
    <span v-if="showSelectButton" class="mask">{{ currentSelectMask }}</span>
    <masked-input v-if="mask" v-model="text" :ref="'text_input_' + id" :id="'maskedInput' + id" class="loginInput_text" :placeholder="placeholder" :mask="mask" :show-mask="false" :guide="false" :autocomplete="autocomplete" required></masked-input>
    <input
      v-else
      v-model="text"
      ref="input"
      :id="'input' + id"
      class="loginInput_text"
      :placeholder="placeholder"
      :type="currentTypeTextfield"
      :readonly="readonly"
      :maxlength="maxlength"
      :inputmode="inputmode"
      :autocomplete="autocomplete"
      @focus="focusOnInput"
      @blur="$listeners.blur ? $listeners.blur() : null"
    />

    <div class="lable">
      <div class="placeholder">{{ lable }}</div>
    </div>
    <div v-if="isNotValid && validMessage" class="validText">{{ validMessage }}</div>
    <div v-if="!(isNotValid && validMessage) && isValidInput.length" class="validText">{{ isValidInput }}</div>
    <div v-if="type == 'password'" class="trailingIcon" @click="trailingAction">
      <svg v-if="currentTypeTextfield == 'password'" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M12 5.99995C15.6254 5.99995 18.8757 7.949 20.5954 11.0681C20.7437 11.3371 20.7447 11.6631 20.597 11.9324C20.0282 12.9695 19.281 13.8721 18.41 14.62L19.82 16.03C21.0166 14.9711 21.9983 13.6825 22.6885 12.2216C22.9043 11.7648 22.9037 11.2353 22.6876 10.7786C20.792 6.77313 16.7215 3.99995 12 3.99995C10.73 3.99995 9.51 4.19995 8.36 4.56995L10.01 6.21995C10.66 6.08995 11.32 5.99995 12 5.99995ZM10.93 7.13995L13 9.20995C13.57 9.45995 14.03 9.91995 14.28 10.49L16.35 12.56C16.43 12.22 16.49 11.86 16.49 11.49C16.5 9.00995 14.48 6.99995 12 6.99995C11.63 6.99995 11.28 7.04995 10.93 7.13995ZM2.71241 3.16256C2.32424 3.55348 2.32506 4.18501 2.71461 4.57456L4.69 6.54995C3.26232 7.67107 2.09548 9.1144 1.31041 10.7792C1.0952 11.2355 1.09614 11.7642 1.31192 12.2203C3.20724 16.2263 7.27809 19 12 19C13.52 19 14.98 18.71 16.32 18.18L19.0349 20.8949C19.4243 21.2843 20.0557 21.2843 20.4451 20.8949C20.8344 20.5055 20.8345 19.8743 20.4453 19.4849L4.12961 3.15996C3.73814 2.76827 3.1026 2.7696 2.71241 3.16256ZM9.51 11.37L12.12 13.98C12.08 13.99 12.04 14 12 14C10.62 14 9.5 12.88 9.5 11.5C9.5 11.45 9.51 11.42 9.51 11.37ZM6.11 7.96995L7.86 9.71995C7.63 10.27 7.5 10.87 7.5 11.5C7.5 13.98 9.52 16 12 16C12.63 16 13.23 15.87 13.77 15.64L14.75 16.62C13.87 16.86 12.95 17 12 17C8.37556 17 5.12609 15.052 3.40603 11.9344C3.25683 11.664 3.25661 11.336 3.40642 11.0659C4.09221 9.82955 5.02467 8.79516 6.11 7.96995Z"
          fill="#7B7B7B"
        />
      </svg>
      <svg v-else width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M12 6C15.6244 6 18.8739 7.94795 20.5939 11.0655C20.7432 11.3359 20.7432 11.6641 20.5939 11.9345C18.8739 15.052 15.6244 17 12 17C8.37558 17 5.12612 15.0521 3.40606 11.9345C3.25684 11.6641 3.25684 11.3359 3.40606 11.0655C5.12612 7.94795 8.37558 6 12 6ZM12 4C7.27924 4 3.20921 6.77233 1.3133 10.7768C1.09657 11.2346 1.09657 11.7654 1.3133 12.2232C3.20921 16.2277 7.27924 19 12 19C16.7208 19 20.7908 16.2277 22.6867 12.2232C22.9034 11.7654 22.9034 11.2346 22.6867 10.7768C20.7908 6.77233 16.7208 4 12 4ZM12 9C13.38 9 14.5 10.12 14.5 11.5C14.5 12.88 13.38 14 12 14C10.62 14 9.5 12.88 9.5 11.5C9.5 10.12 10.62 9 12 9ZM12 7C9.52 7 7.5 9.02 7.5 11.5C7.5 13.98 9.52 16 12 16C14.48 16 16.5 13.98 16.5 11.5C16.5 9.02 14.48 7 12 7Z"
          fill="#7B7B7B"
        />
      </svg>
    </div>
    <div v-if="type == 'calendar'" class="trailingIcon" @click="trailingAction">
      <md-datepicker id="calendar" v-model="selectedDate" md-immediately :md-disabled-dates="isDateDisabled" />
    </div>
    <!-- TODO del if-->
    <div v-if="trailingIcon" class="trailingIcon" @click="trailingAction" v-html="trailingIcon"></div>
    <div class="trailingIconSlot">
      <slot name="trailingIconSlot"></slot>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import LoginSelectCode from './login-select-code';
import Profile from '../../helpers/profile';

export default {
  name: 'login-input',
  components: {LoginSelectCode}, //NpcCalendar
  props: {
    id: String,
    placeholder: String,
    value: String,
    isNotValid: Boolean,
    validMessage: String,
    mask: {
      type: [Array, Function],
      default: () => {
        return null;
      },
    },
    type: {type: String, default: 'text'}, //  calendar, password
    inputmode: {type: String},
    selectArray: {type: Array},
    langIconSrc: String,
    langIcon: String,
    trailingIcon: String,
    lable: String,
    readonly: Boolean,
    maxlength: Number,
    autocomplete: String,
  },
  data() {
    return {
      isWatchDate: false,
      text: this.value,
      currentTypeTextfield: this.type,
      focused: false,
      calendarData: {
        selectedDate: this.$moment().format('DD/MM/YYYY'),
      },

      isNotValidData: false,
      validDateMessage: 'Невірна дата',

      selectedDate: (this.value ? this.$moment(this.value, 'DD/MM/YYYY') : this.$moment().set('year', this.$moment().get('year') - (Profile.process == 'accessRecovery' ? 0 : 14))).toDate(),
      currentSelectItem: this.selectArray ? this.selectArray[0] : null,
    };
  },
  mounted: function() {
    this.$material.locale.firstDayOfAWeek = 1;
    this.$material.locale.dateFormat = 'dd/MM/yyyy';
    this.$material.locale.months = this.$ml.get('monthNames');
    this.$material.locale.shortMonths = this.$ml.get('shortMonths');
    this.$material.locale.shortDays = this.$ml.get('shortDays');
    this.$material.locale.shorterDays = this.$ml.get('shortDayNames');
    let year = this.$moment().get('year');
    if (Profile.process == 'accessRecovery') {
      this.$material.locale.startYear = year - 121;
      this.$material.locale.endYear = year;
    } else {
      this.$material.locale.startYear = year - 100;
      this.$material.locale.endYear = year - 14;
    }
    // this.$material.locale.endYear = year;
  },
  computed: {
    isValidInput: function() {
      if (this.type == 'calendar' && this.text) {
        this.isNotValidData = true;
        if (this.text.replace(/\D/g, '').length == 8) {
          let date = this.$moment(this.text.replace(/\D/g, ''), ['DDMMYYYY']);
          if (date.isValid()) {
            this.isNotValidData = false;
            return '';
          } else return this.validDateMessage;
        } else {
          return this.validDateMessage;
        }
      } else return '';
    },
    showSelectButton: function() {
      return this.selectArray && this.selectArray.length;
    },
    currentSelectMask: function() {
      return this.currentSelectItem ? this.currentSelectItem.maskPlaceholder : '';
    },
  },
  watch: {
    selectedDate(val) {
      // console.log(val);
    },
    text: function(val) {
      Vue.nextTick().then(() => {
        if (this.mask) {
          this.$emit('input', val.replace(/\D/g, ''));
        } else {
          this.$emit('input', val.replace(/\s+/g, ' ').trim());
        }
      });
    },
    value: function(val) {
      this.text = val;
    },
    type: function(val) {
      if (val == 'calendar') this.currentTypeTextfield = 'text';
      else this.currentTypeTextfield = val;
    },
    calendarDataStr: function(val) {
      this.text = val;
    },
    mask: function(val) {
      Vue.nextTick().then(() => {
        if (val) {
          document.getElementById('maskedInput' + this.id).focus();
        } else {
          document.getElementById('input' + this.id).focus();
          this.text = '';
        }
      });
    },
    selectedDate: function(val) {
      if (this.isWatchDate) this.text = this.$moment(val).format('DD/MM/YYYY');
      else this.isWatchDate = true;
    },
  },
  methods: {
    trailingAction: function() {
      if (this.type === 'password') {
        this.currentTypeTextfield = this.currentTypeTextfield == 'password' ? 'text' : 'password';
      } else if (this.type === 'calendar') {
      }
    },
    selectItemSet: function(data) {
      this.currentSelectItem = data;
      this.$emit('selectItemSet', data);
    },
    focusOnInput: function() {
      if (this.type === 'calendar') {
        this.$refs['input'].blur();
        document
          .getElementById('calendar')
          .getElementsByClassName('md-icon')[0]
          .click();
      }
    },
    isDateDisabled: function(data) {
      let years = this.$moment().diff(data, 'years');
      if (Profile.process == 'accessRecovery') return years > 121;
      else return years < 14 || years > 100;
    },
  },
};
</script>

<style lang="scss" scoped>
/*.rightContent  */
.rightContent .loginInput:focus-within .placeholder {
  color: #5cd69b;
}

.loginInput {
  position: relative;
  height: 46px;
  box-sizing: border-box;
  margin-top: 26px;
  &:focus {
    outline: none;
  }
  input {
    width: 100%;
    font-weight: 500;
    font-size: 16px;
    line-height: 19px;
    outline: none;
    white-space: nowrap;
    text-overflow: ellipsis;
    color: rgba(0, 0, 0, 0.87);
    caret-color: #33332f;
    padding: 12px;
    border: 1px solid #bdd6e6;
    border-radius: 8px;
    box-sizing: border-box;
    background: transparent;
    box-shadow: none;
  }

  input:focus {
    padding: 11px;
    border: 2px solid #5cd69b;
    box-sizing: border-box;
    border-radius: 8px;
  }
  &.notValid input {
    padding: 11px;
    border: 2px solid #ec3421;
    box-sizing: border-box;
    border-radius: 8px;
  }
  &::placeholder {
    color: #d9d9d9;
    font-weight: 500;
    font-size: 16px;
    line-height: 19px;
  }
  .validText {
    font-weight: 500;
    font-size: 12px;
    line-height: 14px;
    margin-top: 4px;
    margin-left: 12px;
    color: #e53935;
    text-align: left;
    padding-right: 5px;
  }
  .trailingIcon {
    position: absolute;
    right: 14px;
    top: 7px;
    color: rgba(0, 0, 0, 0.4);
    text-align: right;
    z-index: 1;
    cursor: pointer;
    .md-field {
      height: 32px;
      min-height: 32px;
    }
  }
  .selectButton {
    float: left;
    width: 20%;
  }
  .mask {
    float: left;
    position: absolute;
    /*margin-top: 17px;*/
    margin-top: 12px;
    margin-left: 16px;
    font-weight: 500;
    font-size: 16px;
    line-height: 19px;
    color: rgba(0, 0, 0, 0.38);
  }
  &.selectMask input {
    width: 80%;
    padding-left: 55px;
    &:focus {
      padding-left: 54px;
    }
  }

  .lable {
    display: none;
  }
  .trailingIconSlot {
    position: absolute;
    right: 16px;
    top: 0;
    color: rgba(0, 0, 0, 0.4);
    text-align: right;
    z-index: 1;
    cursor: pointer;
    height: 46px;
    display: flex;
    align-items: center;
  }
}

@media (min-width: 601px) and (max-width: 750px) {
  .loginInput.selectButton {
    float: left;
    width: 58px;
  }

  .loginInput.selectMask input {
    float: right;
    width: calc(35vw - 70px);
  }
  .loginInput {
    height: 54px;
    margin-top: 34px;
    margin-bottom: 32px;
    input {
      padding: 16px;
    }
    input:focus {
      padding: 15px;
    }
    &.notValid input {
    }
    .mask {
      margin-top: 17px;
    }
    .trailingIconSlot {
      height: 54px;
    }
  }
}
@media (min-width: 751px) {
  .loginInput.selectButton {
    float: left;
  }
  .loginInput.selectMask input {
    float: right;
    width: 80%;
  }
  .loginInput {
    height: 54px;
    margin-top: 34px;
    margin-bottom: 32px;
    input {
      padding: 16px;
    }
    input:focus {
      padding: 15px;
    }
    &.notValid input {
      padding: 15px;
    }
    .validText {
      font-size: 14px;
      line-height: 18px;
      margin-top: 6px;
    }
    .mask {
      margin-top: 17px;
    }
    .trailingIcon {
      top: 10px;
    }
    .trailingIconSlot {
      height: 54px;
    }
  }
}
</style>
